import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import Groups from '@mui/icons-material/Groups';
import Shield from '@mui/icons-material/Shield';
import Cloud from '@mui/icons-material/Cloud';
import { readableHeading } from '../readablePalette';

const items = [
  {
    icon: <Groups fontSize="large" />,
    title: 'Audiencia calificada',
    text: 'El programa llega a la «directiva del hogar» (25–45 años), líderes corporativos y profesionales que necesitan proteger sus activos.',
  },
  {
    icon: <Shield fontSize="large" />,
    title: 'Efecto halo',
    text: 'Asociar la firma a la seguridad y el bienestar familiar proyecta un mensaje corporativo inquebrantable de protección.',
  },
  {
    icon: <Cloud fontSize="large" />,
    title: 'Exposición On-Demand',
    text: 'Con más de 30.000 visitas mensuales en la plataforma, la marca no desaparece tras la emisión; vive en la bóveda digital de TNO.',
  },
];

const WhyAlliance = () => {
  const theme = useTheme();
  const h = readableHeading(theme);

  return (
    <Box marginY={4}>
      <Typography variant="overline" sx={{ fontWeight: 700, letterSpacing: '0.12em', color: theme.palette.secondary.main }}>
        Valor para Hoet & Partners
      </Typography>
      <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 700, color: h, fontFamily: 'Georgia, serif', mt: 0.5 }}>
        Por qué esta alianza tiene sentido
      </Typography>
      <Grid container spacing={3} sx={{ mt: 0.5 }}>
        {items.map((item) => (
          <Grid item xs={12} md={4} key={item.title}>
            <Box
              sx={{
                height: '100%',
                p: 2,
                borderRadius: 2,
                border: `1px solid rgba(196, 164, 93, 0.35)`,
                bgcolor: theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.15)' : theme.palette.background.paper,
              }}
            >
              <Box sx={{ color: theme.palette.secondary.main, mb: 1 }}>{item.icon}</Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: h, mb: 1 }}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.65 }}>
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WhyAlliance;
